import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect';
import Swup from 'swup';
import SwupPreloadPlugin from '@swup/preload-plugin';
import collapse from '@alpinejs/collapse'
import gsap from "gsap";
import TextPlugin from "gsap/TextPlugin";
import SplitText from 'gsap/SplitText';
import axios from 'axios';
import { clearAllBodyScrollLocks } from 'body-scroll-lock';

gsap.registerPlugin(TextPlugin, SplitText);

Alpine.plugin(intersect);
Alpine.plugin(collapse);
window.Alpine = Alpine;

Alpine.store('projectHover', { 
    on: false,

    toggle() {
        this.on = !this.on
    }
})

Alpine.store('comingHover', {
    on: false,

    toggle() {
        this.on = !this.on
    }
})

Alpine.data('contactForm', () => ({
    success: false,
    errors: false,
    submitting: false,
    errorText: '',

    init() {
        const form = this.$refs.form;

        form.addEventListener('submit', (e) => {
            e.preventDefault();

            this.submitting = true;

            axios.post(this.$refs.form.getAttribute('action'), new FormData(form), {
                  headers: {
                    'X-CSRF-Token': {
                        toString: () => this.$refs.form.querySelector('[name="_token"]').value,
                    }
                  }
                })
                .then(response => {
                    let parser = new DOMParser();
                    const doc = parser.parseFromString(response.data, 'text/html');

                    if (doc.querySelector('.js-contact-errors')) {
                        this.errors = true;
                        this.errorText = doc.querySelector('.js-contact-errors span').innerHTML;
                    } else {

                        if(this.$el.getAttribute('data-success-redirect')) {
                            window.location.replace(this.$el.getAttribute('data-success-redirect'));
                        } else {
                            this.success = true;
                            this.errors = false;
                            this.errorText = '';
                            form.reset();
                        }
                    }

                    this.submitting = false;
                })
                .catch((error) => {
                    // handle error
                    this.errors = true;
                    this.errorText = 'There has been an error submitting your enquiry.';
                    console.log(error);

                    this.submitting = false;
                })
        });
    }
}));

window.homeAnimationComplete = false;
Alpine.start();

const body = document.body;
const select = e => document.querySelector(e);
const selectAll = e => document.querySelectorAll(e);

const swup = new Swup({
    animationSelector: '[class*="page-transition-"]',
    plugins: [new SwupPreloadPlugin()]
});

init();

function init() {
    Alpine.store('projectHover').on = false;
    Alpine.store('comingHover').on = false;
    setVHUnits();
    customCursor();
    addHoverEffectsToBardLinks();
    homeLoader();
}

function setVHUnits(){
    window.addEventListener('load', () => {
        // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
        let vh = window.innerHeight * 0.01;
        // Then we set the value in the --vh custom property to the root of the document
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    });

    // We listen to the resize event
    window.addEventListener('resize', () => {
        // We execute the same script as before
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);

        if (window.innerWidth > 1023) {
          clearAllBodyScrollLocks();
        }
    });
}

let homeAnimationEvent = new CustomEvent("homeAnimationComplete", {});

function homeLoader (){

    var animationWrapper = select(".js-home-animation");

    if (animationWrapper && window.homeAnimationComplete) {
        animationWrapper.classList.add('animation-finished');
    }

    var main = select("main");
    var loader = select(".js-preloader");
    var words = select(".js-preloader-words");
    var some = select(".js-preloader-logo");
    var studio = select(".js-preloader-logo-2");
    var heroImage = select(".js-hero-image");
    var header = select("header");


    if(animationWrapper && !window.homeAnimationComplete) {
        const tl = gsap.timeline({repeat: 0, repeatDelay: 1});
        // tl.set(header, {right:'-40px' });
        tl.set(heroImage, {opacity:0 });
        tl.set(studio, {display:"none" });
        tl.set(main, {background:'#E7E2DC' });
        tl.set(studio, {opacity:0 });
        tl.set(animationWrapper, {color:'black' });
        tl.set(loader, {position:'absolute', top: '50%', left: '50%', transform:'translateY(-50%) translateX(-50%)' });
        tl.to(words, {duration: 0.15, delay: 1, text: {value: "Interiors.", delimiter: "", type: "diff"} });
        tl.to(words, {duration: 0.15, text: {value: "Design.", delimiter: "", type: "diff"} });
        tl.to(words, {duration: 0.15, text: {value: "Designers.", delimiter: "", type: "diff"} });
        tl.to(words, {duration: 0.15, text: {value: "People.", delimiter: "", type: "diff"} });
        tl.to(words, {duration: 0.15, text: {value: "Places.", delimiter: "", type: "diff"} });
        tl.to(words, {duration: 0.15, text: {value: "Process.", delimiter: "", type: "diff"} });
        tl.to(words, {duration: 0.15, text: {value: "Practice.", delimiter: "", type: "diff"} });
        tl.to(words, {duration: 1, ease: "Power3.easeIn", opacity: 0, display: 'none' }, "+=0.5");
        tl.to(studio, {duration: 1, ease: "Power3.easeIn", opacity: 1, display:"inline-block" } );
        tl.to(animationWrapper, {duration: 1, ease: "Power3.easeIn", color: '#FFFFFF' }, "<");
        tl.to(heroImage, {duration: 1, ease: "Power3.easeIn", opacity: 1 }, "<");
        tl.to(header, {duration: 0.05, ease: "Power3.easeIn", right: '0',  onComplete: () => {
            if (document.querySelector('.js-home-animation')) {
                window.homeAnimationComplete = true;
                document.dispatchEvent(homeAnimationEvent);
                document.querySelector('.js-home-animation').classList.add('animation-finished');
            }
        }, });
    }
}

function customCursor() {
    var cursor = select('.js-cursor');
    document.addEventListener('mousemove', t => {
        var curX = t.clientX;
        var curY = t.clientY;
        cursor.style.transform =
            'translate(calc(' + curX + 'px - 50%),calc(' + curY + 'px - 50%))';
    });

    document.addEventListener('mouseleave', () => {
        cursor.classList.remove('!block');
    });
}

function addHoverEffectsToBardLinks() {
    const bardHoverElements = document.querySelectorAll('.js-cursor-hover');

    if(bardHoverElements) {
        bardHoverElements.forEach((element) => {
            element.addEventListener('mouseover', () => {
                document.querySelector('.js-cursor .cursor').classList.add('scale-75');
                console.log('link hovered')
            });
            element.addEventListener('mouseleave', () => {
                document.querySelector('.js-cursor .cursor').classList.remove('scale-75');
            });
        });
    }
}



swup.on('contentReplaced', function (event) {
    window.scrollTo(0, 0);
    init();
    customCursor();
    addHoverEffectsToBardLinks();
});
